import React from "react";
import ClaritickMockup from "../mockup/ClaritickMockup";

const InteractiveDemoSection = () => (
    <section className="clk-section clk-section-demo" id="demo">
        <div className="clk-container">
            <div className="clk-section-head clk-reveal">
                <span className="clk-eyebrow"><span className="clk-dot" /> Try it live</span>
                <h2>Explore Claritick yourself.</h2>
                <p>
                    Click through the sidebar, open tickets, change statuses, build embed forms, and
                    explore reports, exactly like the real app.
                </p>
            </div>
            <div className="clk-demo-wrap clk-reveal">
                <span className="clk-hiw-step-shot-frame">
                    <span className="clk-hiw-step-device">
                        <span className="clk-hiw-step-device-bar" aria-hidden="true">
                            <i /><i /><i />
                            <span className="clk-hiw-step-device-url">claritick.com</span>
                        </span>
                        <span className="clk-hiw-step-device-screen clk-demo-device-screen">
                            <ClaritickMockup variant="full" defaultView="tickets" />
                        </span>
                    </span>
                    <span className="clk-hiw-step-device-stand" aria-hidden="true">
                        <span className="clk-hiw-step-device-neck" />
                        <span className="clk-hiw-step-device-base" />
                    </span>
                </span>
            </div>
        </div>
    </section>
);

export default InteractiveDemoSection;
